module.exports = __webpack_public_path__ + "img/w3_close_light.75367f4f.png";